<template>
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <drop-down
        v-if="anyChecked"
        :items="checkedActions"
        class="actions-dropdown pt-2 text-black"
        normal-size
        always-show-dropdown
      />
    </page-header>

    <div
      v-if="
        showUpdateLocation &&
          isDetailTab &&
          !isThereCseeLocationTypeChecked &&
          (areOnlySchoolLocationTypeChecked ||
            areOnlyCenterLocationTypeChecked) &&
          isThereOneChecked
      "
      class="py-4 px-4 bg-gray mb-3"
    >
      <update-location
        :materials="checkeds"
        @close="onSearchHandler()"
        :are-only-school-location-type-checked="
          areOnlySchoolLocationTypeChecked
        "
        :are-only-center-location-type-checked="
          areOnlyCenterLocationTypeChecked
        "
      />
    </div>

    <board class="mb-4" :details="boardDetails">
      <template #data-item="{ item }">
        <div v-if="!item.data">
          <custom-balloon
            :background-color="item.statusColor"
            :text="item.statusName"
            dot
          />
        </div>
      </template>
    </board>

    <div class="mb-4">
      <q-tab :active-tab="activeTab">
        <q-tab-item
          :lazy="loadComponent(key)"
          v-for="(tab, key) in tabs"
          :key="key"
          :tabindex="key"
          :title="tab.title"
          :has-error="!tab.valid"
          :visible="tab.visible"
          :nav-item-class="tab.classes"
          @click="setCurrentTab(key)"
        >
          <component
            :inventory-catalog-id="catalogId"
            :is="tab.id"
            :ref="tab.id"
            :code="tab.id"
            :data="tab.data"
            :inventory="inventory"
            @loaded="setTabLoaded"
          ></component>
        </q-tab-item>
      </q-tab>
    </div>
    <div v-if="canViewResultSection">
      <filter-manager
        ref="filter"
        v-model="filter.model"
        :filters="filtersHeader"
        class="filter-manager_extended"
        search-container-class="search-btn"
        @center="onCenterChange"
        @municipality="onMunicipalityChange"
        @search="onSearchHandler()"
      />
      <div class="row my-3" v-if="showChecks">
        <div class="col-12">
          <checkbox
            checked-bg-color="bg-success"
            icon="fal fa-check"
            :text="allCheckedText"
            class="d-flex justify-content-end text-green"
            v-model="allChecked"
            @input="checkAll"
          />
        </div>
      </div>
      <custom-separator
        class="my-3 custom-separator"
        text="Listado de Materiales/Equipos"
      />
      <div v-if="hasResults">
        <template v-if="isDetailTab">
          <result-row
            v-for="(item, index) in results"
            :key="index"
            :item="item"
            :can-view-status-summary="canViewStatusSummary"
            :checkable="showChecks"
            :centers="filter.options.centers"
            @open="handlerOpen"
            @close="handlerClose"
            @refresh="refresh"
            @check="onCheckItem"
            :is-caat-alert-activated="isMissingCaatAlertActivated"
          />
        </template>
        <template v-if="isSummaryTab">
          <result-row-summary
            v-for="(item, index) in results"
            :key="index"
            :item="item"
            :can-view-status-summary="canViewStatusSummary"
            @open="handlerOpen"
            @close="handlerClose"
            @refresh="refresh"
          />
        </template>
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
      <custom-result-not-found v-else text="No hay Información Disponible." />
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import Checkbox from 'CheckBox';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import storeMixin from '@/mixin/storeGenerator';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import inventoryCatalogService from '@/services/api/materialsAndEquipments.api';
import CustomBalloon from 'custom-balloon';
import TABS from '@/utils/constants/materialsEquipmentsTabs';
import { Summary, Detail } from './tabs';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import locationService from '@/services/api/location.api';
import ResultRow from './components/ResultRow.vue';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import peiAtServiceEquipmentStatus from '@/utils/constants/inventory/peiAtServiceEquipmentStatus';
import equipmentsActionType from '@/utils/constants/inventory/peiAtServiceEquipmentsActionType';
import { date } from '@/utils/filters';
import LocationTypes from '@/utils/constants/inventory/inventoryOrderBookLocationTypes';
import materialsService from '@/services/api/materialsEquipment.api.js';
import UpdateLocation from './components/UpdateLocation.vue';
import ResultRowSummary from './components/ResultRowSummary.vue';

const DEFAULT_PAGE_SIZE = 5;

const INVENTORY_MAINTENANCE_ROUTE_NAME = 'inventoryMaintenance';

export default {
  components: {
    PageHeader,
    Board,
    QTab,
    QTabItem,
    ActionButton,
    DropDown,
    CustomBalloon,
    Checkbox,
    Summary,
    Detail,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
    Pagination,
    UpdateLocation,
    ResultRowSummary,
  },
  mixins: [alertMixin, storeMixin],
  created() {
    this.activeTab = this.tabParam;
  },
  data: () => ({
    showUpdateLocation: false,
    inventory: {},
    statusSummary: [],
    activeTab: TABS.Summary,
    tabKey: 0,
    loading: false,
    tabsLoaded: [
      { id: TABS.Summary, lazy: true, loaded: false, visible: true },
      { id: TABS.Detail, lazy: true, loaded: false, visible: true },
    ],
    filter: {
      model: {
        saloonType: null,
        status: null,
        code: null,
        center: null,
        municipality: null,
        school: null,
      },
      options: {
        saloonTypes: [],
        statuses: [],
        centers: [],
        municipalities: [],
        schools: [],
      },
    },
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: DEFAULT_PAGE_SIZE,
    },
    results: [],
    allChecked: false,
    allCheckedIgnoreCallback: false,
    isMissingCaatAlertActivated: false,
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    isSummaryTab() {
      return this.activeTab == TABS.Summary;
    },
    isDetailTab() {
      return this.activeTab == TABS.Detail;
    },
    canViewResultSection() {
      return [TABS.Summary, TABS.Detail].includes(this.activeTab);
    },
    canViewStatusSummary() {
      return [TABS.Detail].includes(this.activeTab);
    },
    loadComponent() {
      return (tab) => {
        const item = this.tabsLoaded
          .filter((x) => x.visible)
          .find((x) => x.id == tab);
        return item?.lazy;
      };
    },
    catalogId() {
      return Number(this.$route.params.id);
    },
    tabParam() {
      return Number(this.$route.query.tab ?? TABS.Dashboard);
    },
    headerPage() {
      return {
        icon: 'fas fa-book-open',
        title: 'Catálogo de Materiales/Equipos',
        routes: ['Inicio', 'PEI', 'Catálogo de Materiales', 'Equipos'],
      };
    },
    hasResults() {
      return Boolean(this.results?.length);
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
        {
          text: 'Cargar',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: () =>
            this.$router.push({
              name: 'materials-and-equipments-load',
              params: { id: this.catalogId },
            }),
        },
      ];
    },
    filtersHeader() {
      return [
        {
          name: 'saloonType',
          component: 'CustomDropDown',
          options: this.filter.options.saloonTypes,
          value: this.filter.model.saloonType,
          placeholder: 'Tipo de Salón',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
        },
        {
          name: 'code',
          component: 'CustomInput',
          value: this.filter.model.code,
          placeholder: 'Escriba Código o Nombre de Material/Equipo',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md',
          type: 'text',
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          value: this.filter.model.center,
          options: this.filter.options.centers,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          value: this.filter.model.municipality,
          options: this.filter.options.municipalities,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
        {
          name: 'school',
          label: 'Escuela:',
          component: 'CustomDropDown',
          value: this.filter.model.school,
          options: this.filter.options.schools,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-4 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
        },
      ];
    },
    showNotResults() {
      return this.result.length == 0;
    },
    boardDetails() {
      return [
        [
          {
            label: 'Categoría:',
            icon: 'fas fa-file',
            data: this.inventory?.name,
            cols: 'col-12 col-md-3 pt-2',
          },
          {
            label: 'Nombre del Materiales/Equipos:',
            icon: 'fas fa-file',
            data: this.inventory?.categoryName,
            cols: 'col-12 col-md-3 pt-2',
          },
          {
            label: 'Estatus:',
            icon: 'fas fa-file',
            statusColor: this.inventory?.statusColor,
            statusName: this.inventory?.statusName,
            cols: 'col-12 col-md-3 pt-2',
          },
          {
            label: 'Última fecha de Inventario:',
            icon: 'fas fa-calendar-minus',
            data: date(this.inventory?.lastDate),
            cols: 'col-12 col-md pt-2',
          },
        ],
      ];
    },
    tabs() {
      const allTabs = [
        {
          id: 'Summary',
          title: 'Resumen',
          valid: true,
          visible: true,
          data: {},
        },
        {
          id: 'Detail',
          title: 'Detalles',
          valid: true,
          visible: true,
          data: {},
        },
      ];
      return allTabs;
    },
    allCheckedText() {
      return this.allChecked
        ? `Deseleccionar Todo (${this.results.filter((x) => x.checked).length})`
        : 'Seleccionar Todo';
    },
    anyChecked() {
      return this.results.some((x) => x.checked);
    },
    allProcessed() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Processed
        ) && Boolean(this.results.length)
      );
    },
    allInactivated() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Inactive
        ) && Boolean(this.results.length)
      );
    },
    allReturned() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Returned
        ) && Boolean(this.results.length)
      );
    },
    filterInactivated() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Inactive
      );
    },
    filterReturned() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Returned
      );
    },
    filterProcessed() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Processed
      );
    },
    filterAvailable() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Available
      );
    },
    showChecks() {
      return (
        this.canViewStatusSummary &&
        ((this.allProcessed && this.filterProcessed) ||
          (this.allAvailable && this.filterAvailable) ||
          (this.allInactivated && this.filterInactivated) ||
          (this.allReturned && this.filterReturned))
      );
    },
    allAvailable() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Available
        ) && Boolean(this.results.length)
      );
    },
    isThereCseeLocationTypeChecked() {
      return this.checkeds.some(
        (x) => x.locationTypeId == LocationTypes.CSEE.id
      );
    },
    areOnlySchoolLocationTypeChecked() {
      return this.checkeds.every(
        (x) => x.locationTypeId == LocationTypes.SCHOOL.id
      );
    },
    areOnlyCenterLocationTypeChecked() {
      return this.checkeds.every(
        (x) => x.locationTypeId == LocationTypes.CENTER.id
      );
    },
    isThereOneChecked() {
      return Boolean(this.checkeds?.length > 0);
    },
    checkedActions() {
      return [
        {
          visible: this.allProcessed || this.allInactivated || this.allReturned,
          name: 'Marcar Disponibles',
          icon: 'fas fa-file-check text-green',
          click: () =>
            this.applyActionToEquipments(equipmentsActionType.MarkAvailable),
        },
        {
          name: 'Inactivar',
          icon: 'fas fa-ban text-muted',
          visible:
            (this.allProcessed || this.allAvailable) &&
            this.userHasPermissions(
              'academic.inventory.inactivematerialequipment'
            ),
          click: () =>
            this.applyActionToEquipments(equipmentsActionType.Inactivate),
        },
        {
          name: 'Actualizar Localidad',
          icon: 'fas fa-map-marker-alt text-green',
          click: () => this.displayUpdateLocation(),
          visible:
            (this.allProcessed || this.allAvailable) &&
            !this.isThereCseeLocationTypeChecked &&
            this.userHasPermissions('academic.pei.assigncentermaterial'),
        },
        {
          name: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          visible:
            (this.allProcessed || this.allAvailable) &&
            this.userHasPermissions(
              'academic.inventory.deletematerialequipment'
            ),
          click: () =>
            this.applyActionToEquipments(equipmentsActionType.Eliminate),
        },
      ];
    },
    checkeds() {
      if (this.allAvailable || this.allProcessed)
        return this.results.filter((x) => x.checked);
      return [];
    },
  },
  async mounted() {
    Promise.all([this.getSaloonTypes(), this.getCenters(), this.getStatus()]);
    await this.initData();
  },
  methods: {
    displayUpdateLocation() {
      if (
        this.areOnlyCenterLocationTypeChecked ||
        this.areOnlySchoolLocationTypeChecked
      ) {
        this.showUpdateLocation = true;
        return;
      }

      this.ShowToast(
        'Advertencia.',
        'Los seleccionados deben ser del mismo tipo de localidad.',
        'warning'
      );
    },
    hideDisplayUpdateLocation() {
      this.showUpdateLocation = false;
    },
    async handleSubmit() {
      const refs = this.tabs
        .filter((x) => x.visible)
        .map(({ id }) => this.$refs[id]);
      await refs[this.activeTab][0].save();
    },
    async initData() {
      await this.getBoardInfo();

      if (this.tabParam) {
        this.setCurrentTab(this.tabParam);
        await this.onSearchHandler();
        this.$forceUpdate();
      } else {
        this.setCurrentTab(TABS.Summary);
      }
    },
    async getBoardInfo() {
      const { data } = await inventoryCatalogService.get(this.catalogId);
      this.inventory = data;
    },
    async getStatusSummary() {
      //to-do
      // const { data } = await inventoryCatalogService.getStatusSummary(
      //   this.catalogId
      // );
      // this.statusSummary = data;
    },
    setTabLoaded(i) {
      if (i == undefined) {
        return;
      }
      const tab = this.tabsLoaded
        .filter((x) => x.visible)
        .find((x) => x.id == i);
      tab.lazy = false;
      tab.loaded = true;
    },
    async setCurrentTab(tab) {
      const sameRoute = this.tabParam === tab;
      if (sameRoute) return;

      this.activeTab = tab;

      if (tab) this.$router.replace({ query: { tab } });
      else this.$router.replace({ name: this.$route.name });

      const tabsToReload = [TABS.Summary, TABS.Detail];
      if (tabsToReload.includes(tab)) {
        await this.onSearchHandler();
      }
    },
    async addMaterial() {
      this.$router.push({
        name: INVENTORY_MAINTENANCE_ROUTE_NAME,
        params: {
          id: this.catalogId,
        },
      });
    },
    async onSearchHandler(page = 1) {
      this.hideDisplayUpdateLocation();
      this.allChecked = false;
      const {
        saloonType,
        center,
        code,
        municipality,
        school,
        status,
      } = this.filter.model;

      const payload = {
        saloonTypeId: (saloonType || {}).id,
        centerId: (center || {}).id,
        code,
        municipalityId: (municipality || {}).id,
        schoolId: (school || {}).id,
        statusId: (status || {}).id,
        pageIndex: page,
        pageSize: this.pagination.pageSize,
      };
      const apiTocall = this.isSummaryTab
        ? inventoryCatalogService.getSearchMaterialsSummary
        : inventoryCatalogService.getSearchMaterials;

      const { data } = await apiTocall(this.catalogId, 0, payload);

      this.results = data.data.map((x) => ({
        ...x,
        isOpen: false,
        checked: false,
      }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async onPageChange(page) {
      this.onSearchHandler(page);
    },
    async getSaloonTypes() {
      const { data } = await materialsService.getSaloonTypes();
      this.filter.options.saloonTypes = data;
    },
    async getStatus() {
      const { data } = await inventoryCatalogService.getInventoryStatus();
      this.filter.options.statuses = data;
    },
    async onCenterChange(value) {
      this.filter.model.municipality = null;
      this.filter.model.school = null;
      this.filter.options.municipalities = [];
      this.filter.options.schools = [];

      if (!value) return;

      await this.getMunicipalities();
    },
    async onMunicipalityChange(value) {
      this.filter.model.school = null;
      this.filter.options.schools = [];

      if (!value) return;

      await this.getSchools();
    },
    async getCenters() {
      const academicYearId = this.currentAcademicYear().id;
      const { data } = await locationService.getCenters({
        academicYearId,
      });
      this.filter.options.centers = data;

      if (this.filter.options.centers.length == 1) {
        this.filter.model.center = this.filter.options.centers[0];
        this.getMunicipalities();
      }
    },
    async getMunicipalities() {
      const centerId = (this.filter.model.center || {}).id;

      if (!centerId) {
        return;
      }

      const academicYearId = this.currentAcademicYear().id;
      const { data } = await locationService.getMunicipalities({
        academicYearId,
        centerId,
      });
      this.filter.options.municipalities = data;

      if (this.filter.options.municipalities.length == 1) {
        this.filter.model.municipality = this.filter.options.municipalities[0];
        this.getSchools();
      }
    },
    async getSchools() {
      const municipalityId = (this.filter.model.municipality || {}).id;

      if (!municipalityId) {
        return;
      }

      const academicYearId = this.currentAcademicYear().id;
      const { data } = await locationService.getSchools({
        academicYearId,
        centerId: this.filter.model.center.id,
        municipalityId,
      });
      this.filter.options.schools = data;

      if (this.filter.options.schools.length == 1) {
        this.filter.model.school = this.filter.options.schools[0];
      }
    },
    async handlerOpen(item) {
      if (this.isSummaryTab) {
        this.results
          .filter((x) => x.key !== item.key && x.isOpen)
          .forEach((x) => (x.isOpen = false));
        item.isOpen = true;
        return;
      }

      this.results
        .filter((x) => x.id !== item.id && x.isOpen)
        .forEach((x) => (x.isOpen = false));

      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    },
    async refresh() {
      await this.onSearchHandler(this.pagination.currentPage);
    },
    checkAll() {
      if (this.allCheckedIgnoreCallback) return;
      this.results.forEach((x) => (x.checked = this.allChecked));
    },
    onCheckItem({ checked }) {
      if (checked) {
        const every = this.results.every((x) => x.checked);
        if (every) this.allChecked = true;
      } else if (this.allChecked) {
        this.allCheckedIgnoreCallback = true;
        this.allChecked = false;
        setTimeout(() => (this.allCheckedIgnoreCallback = false), 100);
      }
    },
    async applyActionToEquipments(action) {
      try {
        const ids = this.results.filter((x) => x.checked).map((x) => x.id);

        this.showUpdateLocation = false;
        this.isMissingCaatAlertActivated = false;

        const checkedEquipmentsWithoutCaat = this.results
          .filter((x) => x.checked)
          .filter((x) => !x.caatId && x.locationTypeId != LocationTypes.CSEE.id)
          .filter((x) =>
            [
              peiAtServiceEquipmentStatus.Processed,
              peiAtServiceEquipmentStatus.Inactive,
            ].includes(x.statusId)
          );

        if (action == equipmentsActionType.MarkAvailable) {
          this.isMissingCaatAlertActivated =
            checkedEquipmentsWithoutCaat.length > 0;

          if (checkedEquipmentsWithoutCaat.length != 0) {
            this.ShowToast(
              'Materiales sin centro seleccionados.',
              'Todos los Materiales deben contar con centro asignado para poder marcarlo disponible.',
              'error'
            );
            return;
          }
        }
        let message = '¿Está seguro que desea ';
        let successMsg = '';
        switch (action) {
          case equipmentsActionType.MarkAvailable:
            message += `cambiar el estatus de (${ids.length}) material(es) de ${this.filter.model.status.name} a Disponible?`;
            successMsg = 'marcados disponibles';
            break;
          case equipmentsActionType.Inactivate:
            message += `cambiar el estatus de (${ids.length}) material(es) de ${this.filter.model.status.name} a Inactivo?`;
            successMsg = 'inactivados';
            break;
          case equipmentsActionType.Eliminate:
            message += `eliminar (${ids.length}) material(es)?`;
            successMsg = 'eliminados';
            break;
        }
        const confirmed = await this.ShowCancelModal('Confirmación', message);
        if (!confirmed) return;
        await inventoryCatalogService.applyActionToMaterial(action, ids);

        this.ShowToast(
          'Éxito',
          `(${ids.length}) material(es) han sido ${successMsg} exitosamente.`,
          'success'
        );
        await this.refresh();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const routes = [
      'InventoryBookDetails',
      'inventory-catalog-books-load',
      'inventory-catalog-books-edit',
      'inventory-catalog-books-add',
    ];
    next(async (vm) => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onPageChange(1);
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
};
</script>
<style scoped lang="scss">
::v-deep .font-weight-bold {
  font-weight: 700 !important;
}

.actions-dropdown ::v-deep #dropdownMenuButton {
  color: #11291b !important;
}
</style>
